export const quizData = {
  factors: [
    {
      id: 1,
      name: "Emotional Stability & Conflict Resolution",
      questions: [
        {
          id: 1,
          text: "How do you typically react when you're upset with your partner?",
          options: [
            { value: 1, text: "Withdraw completely and give them the silent treatment" },
            { value: 3, text: "Take time to cool down, then discuss it when emotions settle" },
            { value: 5, text: "Express your feelings calmly and seek to understand their perspective" }
          ]
        },
        {
          id: 2,
          text: "When your partner criticizes something you've done, how do you respond?",
          options: [
            { value: 1, text: "Become defensive or counterattack with their flaws" },
            { value: 3, text: "Feel hurt but try to listen to what they're saying" },
            { value: 5, text: "Listen openly and consider whether the feedback is valid" }
          ]
        },
        {
          id: 3,
          text: "How do you handle stress from work or other external sources?",
          options: [
            { value: 1, text: "Take it out on those around you, including your partner" },
            { value: 3, text: "Try to manage it alone but sometimes it affects your mood at home" },
            { value: 5, text: "Communicate your stress levels and seek healthy outlets or support" }
          ]
        },
        {
          id: 4,
          text: "When you disagree with your partner on an important issue, what do you do?",
          options: [
            { value: 1, text: "Insist that your way is right and expect them to agree" },
            { value: 3, text: "Compromise reluctantly but may hold onto resentment" },
            { value: 5, text: "Work together to find a solution that honors both perspectives" }
          ]
        },
        {
          id: 5,
          text: "How often do you apologize when you've hurt your partner's feelings?",
          options: [
            { value: 1, text: "Rarely or never; I don't like admitting I'm wrong" },
            { value: 3, text: "Sometimes, but it takes me a while to do so" },
            { value: 5, text: "Readily and sincerely whenever I've caused hurt" }
          ]
        },
        {
          id: 6,
          text: "When facing a major life setback, how do you cope?",
          options: [
            { value: 1, text: "Fall apart emotionally and struggle to function for extended periods" },
            { value: 3, text: "Feel overwhelmed initially but gradually work through it" },
            { value: 5, text: "Process your emotions healthily and seek solutions or support" }
          ]
        },
        {
          id: 7,
          text: "How do you respond when your partner is going through a difficult time?",
          options: [
            { value: 1, text: "Feel uncomfortable and avoid dealing with their emotions" },
            { value: 3, text: "Try to help but sometimes feel unsure how to support them" },
            { value: 5, text: "Offer consistent emotional support and practical assistance" }
          ]
        },
        {
          id: 8,
          text: "How frequently do past hurts or arguments resurface in current disagreements?",
          options: [
            { value: 1, text: "Very often; I bring up old issues regularly" },
            { value: 3, text: "Occasionally, especially during heated moments" },
            { value: 5, text: "Rarely; I focus on resolving current issues and moving forward" }
          ]
        },
        {
          id: 9,
          text: "When you're angry, how do you express it?",
          options: [
            { value: 1, text: "Yell, slam doors, or use hurtful language" },
            { value: 3, text: "Show visible frustration but try to control extreme reactions" },
            { value: 5, text: "Express anger clearly but respectfully without attacking my partner" }
          ]
        },
        {
          id: 10,
          text: "How well do you handle unexpected changes to plans or routines?",
          options: [
            { value: 1, text: "Become very upset and struggle to adapt" },
            { value: 3, text: "Feel annoyed but eventually adjust" },
            { value: 5, text: "Stay flexible and adapt with minimal stress" }
          ]
        }
      ]
    },
    {
      id: 2,
      name: "Communication Style & Intimacy",
      questions: [
        {
          id: 11,
          text: "How openly do you share your deepest feelings and fears with your partner?",
          options: [
            { value: 1, text: "Rarely or never; I keep my vulnerabilities private" },
            { value: 3, text: "Occasionally, when I feel safe or the situation demands it" },
            { value: 5, text: "Regularly and freely; I believe in emotional transparency" }
          ]
        },
        {
          id: 12,
          text: "When your partner wants to discuss relationship concerns, how do you respond?",
          options: [
            { value: 1, text: "Avoid the conversation or dismiss their concerns" },
            { value: 3, text: "Listen but may become uncomfortable or defensive" },
            { value: 5, text: "Welcome the discussion and engage thoughtfully" }
          ]
        },
        {
          id: 13,
          text: "How do you prefer to resolve misunderstandings?",
          options: [
            { value: 1, text: "Hope they resolve themselves without direct conversation" },
            { value: 3, text: "Address them eventually, though I may procrastinate" },
            { value: 5, text: "Discuss them promptly to prevent escalation" }
          ]
        },
        {
          id: 14,
          text: "How often do you express appreciation and affection to your partner?",
          options: [
            { value: 1, text: "Rarely; I assume they know how I feel" },
            { value: 3, text: "Occasionally, during special moments" },
            { value: 5, text: "Regularly through words, actions, and physical affection" }
          ]
        },
        {
          id: 15,
          text: "When discussing sensitive topics, how do you communicate?",
          options: [
            { value: 1, text: "Bluntly without considering my partner's feelings" },
            { value: 3, text: "Carefully but sometimes struggle to find the right words" },
            { value: 5, text: "Tactfully and respectfully, considering both honesty and kindness" }
          ]
        },
        {
          id: 16,
          text: "How comfortable are you discussing physical intimacy with your partner?",
          options: [
            { value: 1, text: "Very uncomfortable; I avoid these conversations" },
            { value: 3, text: "Somewhat comfortable but prefer not to go into detail" },
            { value: 5, text: "Completely comfortable; I believe open dialogue enhances intimacy" }
          ]
        },
        {
          id: 17,
          text: "When your partner shares good news, how do you react?",
          options: [
            { value: 1, text: "Respond minimally or change the subject" },
            { value: 3, text: "Congratulate them but may not fully engage in their excitement" },
            { value: 5, text: "Celebrate enthusiastically and share in their joy" }
          ]
        },
        {
          id: 18,
          text: "How do you handle situations where you and your partner misunderstand each other?",
          options: [
            { value: 1, text: "Blame them for not being clear or understanding" },
            { value: 3, text: "Feel frustrated but try to clarify eventually" },
            { value: 5, text: "Ask questions and seek mutual understanding without blame" }
          ]
        },
        {
          id: 19,
          text: "How responsive are you to your partner's emotional needs?",
          options: [
            { value: 1, text: "Often miss or ignore their emotional cues" },
            { value: 3, text: "Notice sometimes but may not always know how to respond" },
            { value: 5, text: "Attentive and proactive in meeting their emotional needs" }
          ]
        },
        {
          id: 20,
          text: "When you need something from your partner, how do you communicate it?",
          options: [
            { value: 1, text: "Drop hints and expect them to figure it out" },
            { value: 3, text: "Eventually say something directly if hints don't work" },
            { value: 5, text: "Express my needs clearly and directly from the start" }
          ]
        }
      ]
    },
    {
      id: 3,
      name: "Financial Management & Values",
      questions: [
        {
          id: 21,
          text: "How do you approach spending money?",
          options: [
            { value: 1, text: "Impulsively without much planning or consideration" },
            { value: 3, text: "Generally thoughtful but occasionally make unplanned purchases" },
            { value: 5, text: "Deliberately with clear priorities and budget awareness" }
          ]
        },
        {
          id: 22,
          text: "What is your attitude toward saving for the future?",
          options: [
            { value: 1, text: "Live for today; saving can wait" },
            { value: 3, text: "Try to save when possible but not consistently" },
            { value: 5, text: "Prioritize regular savings as an essential financial habit" }
          ]
        },
        {
          id: 23,
          text: "How do you feel about discussing finances with your partner?",
          options: [
            { value: 1, text: "Uncomfortable; I prefer to keep my finances private" },
            { value: 3, text: "Willing to discuss major decisions but keep some things separate" },
            { value: 5, text: "Believe in complete financial transparency and joint planning" }
          ]
        },
        {
          id: 24,
          text: "When faced with a major purchase decision, what do you do?",
          options: [
            { value: 1, text: "Buy what I want without consulting my partner" },
            { value: 3, text: "Mention it to my partner but may decide independently" },
            { value: 5, text: "Discuss thoroughly with my partner before making the decision" }
          ]
        },
        {
          id: 25,
          text: "How do you handle debt?",
          options: [
            { value: 1, text: "Don't worry much about it; debt is just part of life" },
            { value: 3, text: "Try to manage it but sometimes struggle with repayment plans" },
            { value: 5, text: "Work actively to minimize and eliminate debt responsibly" }
          ]
        },
        {
          id: 26,
          text: "What are your expectations about working after marriage?",
          options: [
            { value: 1, text: "Haven't really thought about it or have very fixed expectations" },
            { value: 3, text: "Have preferences but willing to discuss alternatives" },
            { value: 5, text: "Open to various arrangements based on our shared goals and circumstances" }
          ]
        },
        {
          id: 27,
          text: "How do you prioritize financial goals?",
          options: [
            { value: 1, text: "Don't really set specific financial goals" },
            { value: 3, text: "Have general ideas but no concrete plans" },
            { value: 5, text: "Set clear, specific financial goals and work toward them systematically" }
          ]
        },
        {
          id: 28,
          text: "How do you react when your partner spends money differently than you would?",
          options: [
            { value: 1, text: "Criticize or control their spending choices" },
            { value: 3, text: "Feel uncomfortable but may not say much" },
            { value: 5, text: "Respect their autonomy while discussing shared financial values" }
          ]
        },
        {
          id: 29,
          text: "What is your attitude toward financial risk (investments, career changes)?",
          options: [
            { value: 1, text: "Either extremely reckless or overly fearful without balance" },
            { value: 3, text: "Moderately cautious but sometimes uncertain about decisions" },
            { value: 5, text: "Thoughtfully balanced, weighing risks and opportunities carefully" }
          ]
        },
        {
          id: 30,
          text: "How do you handle financial stress or unexpected expenses?",
          options: [
            { value: 1, text: "Panic or ignore the problem hoping it resolves itself" },
            { value: 3, text: "Worry significantly but eventually address it" },
            { value: 5, text: "Face it calmly and work on practical solutions with my partner" }
          ]
        }
      ]
    },
    {
      id: 4,
      name: "Social Compatibility & Family Dynamics",
      questions: [
        {
          id: 31,
          text: "How do you feel about spending time with your partner's family?",
          options: [
            { value: 1, text: "Avoid it whenever possible; they're not my priority" },
            { value: 3, text: "Participate occasionally but find it somewhat draining" },
            { value: 5, text: "Embrace opportunities to build relationships with them" }
          ]
        },
        {
          id: 32,
          text: "How much alone time versus social time do you need?",
          options: [
            { value: 1, text: "Extreme on either end, causing friction with my partner's needs" },
            { value: 3, text: "Have preferences but can compromise sometimes" },
            { value: 5, text: "Balanced and flexible, respecting both our social needs" }
          ]
        },
        {
          id: 33,
          text: "How do you handle differences in friendships or social circles?",
          options: [
            { value: 1, text: "Expect my partner to adopt my friends and abandon theirs" },
            { value: 3, text: "Maintain separate social lives with occasional overlap" },
            { value: 5, text: "Support each other's friendships while building shared connections" }
          ]
        },
        {
          id: 34,
          text: "What role do you expect extended family to play in your marriage?",
          options: [
            { value: 1, text: "Either completely enmeshed or entirely disconnected" },
            { value: 3, text: "Somewhat involved but boundaries can be unclear" },
            { value: 5, text: "Appropriately involved with healthy boundaries and mutual respect" }
          ]
        },
        {
          id: 35,
          text: "How do you approach social obligations and events?",
          options: [
            { value: 1, text: "Refuse to compromise on whether or not to attend" },
            { value: 3, text: "Go along reluctantly or skip events causing disappointment" },
            { value: 5, text: "Discuss and decide together, balancing both preferences" }
          ]
        },
        {
          id: 36,
          text: "How do you handle it when your partner wants different social activities than you?",
          options: [
            { value: 1, text: "Dismiss their preferences or force them to do what I want" },
            { value: 3, text: "Take turns but may show reluctance or resentment" },
            { value: 5, text: "Support their interests enthusiastically even when different from mine" }
          ]
        },
        {
          id: 37,
          text: "What are your expectations about couple time versus individual pursuits?",
          options: [
            { value: 1, text: "Expect constant togetherness or complete independence" },
            { value: 3, text: "Haven't clearly discussed or established expectations" },
            { value: 5, text: "Have discussed and agreed on a healthy balance for both" }
          ]
        },
        {
          id: 38,
          text: "How do you respond when family members interfere in your relationship?",
          options: [
            { value: 1, text: "Either allow interference or cut off family completely" },
            { value: 3, text: "Feel torn and struggle to establish boundaries" },
            { value: 5, text: "Set clear, respectful boundaries that protect the relationship" }
          ]
        },
        {
          id: 39,
          text: "How important is it that your partner gets along with your friends?",
          options: [
            { value: 1, text: "Absolutely critical; they must be best friends with my friends" },
            { value: 3, text: "Somewhat important but causes occasional tension" },
            { value: 5, text: "Valued but I understand they may have different comfort levels" }
          ]
        },
        {
          id: 40,
          text: "How do you handle hosting or visiting obligations?",
          options: [
            { value: 1, text: "Refuse to participate or leave all responsibility to my partner" },
            { value: 3, text: "Help when asked but don't take initiative" },
            { value: 5, text: "Share responsibilities and plan together as a team" }
          ]
        }
      ]
    },
    {
      id: 5,
      name: "Life Planning & Flexibility",
      questions: [
        {
          id: 41,
          text: "What are your views on having children?",
          options: [
            { value: 1, text: "Haven't thought about it or refuse to discuss it" },
            { value: 3, text: "Have some ideas but haven't aligned with my partner" },
            { value: 5, text: "Have discussed openly and reached clear mutual understanding" }
          ]
        },
        {
          id: 42,
          text: "How do you approach major life decisions (career moves, relocations)?",
          options: [
            { value: 1, text: "Make decisions independently without considering my partner's input" },
            { value: 3, text: "Consider my partner's input but may prioritize my own preferences" },
            { value: 5, text: "Make decisions jointly, ensuring both partners' needs are honored" }
          ]
        },
        {
          id: 43,
          text: "How aligned are your long-term goals with your partner's?",
          options: [
            { value: 1, text: "Very different and we haven't discussed how to reconcile them" },
            { value: 3, text: "Somewhat similar with some areas of uncertainty" },
            { value: 5, text: "Well-aligned through ongoing conversation and mutual planning" }
          ]
        },
        {
          id: 44,
          text: "How do you handle differences in religious or spiritual beliefs?",
          options: [
            { value: 1, text: "Insist my partner adopt my beliefs or ignore the differences" },
            { value: 3, text: "Acknowledge differences but haven't fully addressed implications" },
            { value: 5, text: "Respect differences and have discussed how to navigate them together" }
          ]
        },
        {
          id: 45,
          text: "What is your attitude toward personal growth and change?",
          options: [
            { value: 1, text: "Resistant to change; prefer everything to stay the same" },
            { value: 3, text: "Open to change but find it challenging and uncomfortable" },
            { value: 5, text: "Embrace growth and encourage positive development in both partners" }
          ]
        },
        {
          id: 46,
          text: "How do you envision dividing household responsibilities?",
          options: [
            { value: 1, text: "Haven't discussed it or expect traditional/rigid roles" },
            { value: 3, text: "Have general ideas but no specific agreement" },
            { value: 5, text: "Have discussed and agreed on a fair, flexible division of labor" }
          ]
        },
        {
          id: 47,
          text: "How flexible are you when life doesn't go according to plan?",
          options: [
            { value: 1, text: "Become rigid and struggle to adapt to unexpected changes" },
            { value: 3, text: "Adapt slowly with some difficulty" },
            { value: 5, text: "Remain adaptable and work with my partner to adjust plans" }
          ]
        },
        {
          id: 48,
          text: "What is your approach to balancing career ambitions with relationship priorities?",
          options: [
            { value: 1, text: "Career always comes first or relationship must always come first" },
            { value: 3, text: "Try to balance but sometimes one area suffers" },
            { value: 5, text: "Actively work to integrate both with intentional prioritization" }
          ]
        },
        {
          id: 49,
          text: "How do you handle discussions about where to live?",
          options: [
            { value: 1, text: "Insist on my preference without compromise" },
            { value: 3, text: "Have preferences but willing to discuss, though may resist change" },
            { value: 5, text: "Openly discuss options considering both partners' needs and opportunities" }
          ]
        },
        {
          id: 50,
          text: "How do you view the role of ongoing effort in maintaining a healthy marriage?",
          options: [
            { value: 1, text: "Once married, the relationship should take care of itself" },
            { value: 3, text: "Recognize effort is needed but may not consistently prioritize it" },
            { value: 5, text: "Committed to continuous investment, communication, and growth together" }
          ]
        }
      ]
    }
  ]
};